export default __webpack_public_path__ + "static/media/ic-eye.af75952c.svg";